document.addEventListener('DOMContentLoaded',function(){
    //console.log('custom.js')
    (function() {
        function injectStyles(shadow) {
            const styleTag = document.createElement("style");
            styleTag.textContent = `
                .actions-active .active-actions-icon {
                    left: 0;
                }
                .actions-active .icon svg {
                    max-width: 100%;
                    max-height: 100%;
                    padding: 10px;
                }
                .actions-active .active-actions-icon svg {
                    padding: 0;
                }
            `;
            shadow.appendChild(styleTag);
        }

        function tryInject() {
            const accessWidget = document.querySelector("access-widget-ui");
            if (!accessWidget) {
                return false;
            }
            if (!accessWidget.shadowRoot) {
                return false;
            }
            // inject style
            injectStyles(accessWidget.shadowRoot);
            //console.log("Injected styles into shadow root");
            return true;
        }

        // First try after some delay
        setTimeout(() => {
            if (tryInject()) {
                return;
            }
            // If not injected, use observer
            const observer = new MutationObserver((mutations, obs) => {
                if (tryInject()) {
                    obs.disconnect();
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }, 2000);
    })();


});

/*---------------(Imgs)------------------*/
document.addEventListener("DOMContentLoaded", function() {
    //console.log('test')
  const updatedImgs = document.querySelectorAll('.itg-update-img img');
  const PBarNextFrame = document.querySelector('#PBarNextFrame');
  const lazyImages = document.querySelectorAll('.lazy-image');
  document.querySelector('cart-drawer').classList.remove('hide');
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        const img = entry.target;   
        img.src = img.dataset.src;
        img.classList.add('loaded');
        obs.unobserve(img);
      }
    });
  }, { threshold: 0.1 });
   if(updatedImgs.length > 0){
    updatedImgs.forEach(function(updatedImg){
        const dataSrc = updatedImg.getAttribute('data-src');
        updatedImg.src = dataSrc
        updatedImg.srcset = dataSrc
    });
  } 
  if(PBarNextFrame){ 
    PBarNextFrame.setAttribute('title','Shopify theme preview bar');
  } 
  if(lazyImages.length > 0){
    lazyImages.forEach(img => observer.observe(img));
  }
  const drawerOpen = document.querySelector('.header__icon[id="cart-icon"]');
   if(drawerOpen) {
        drawerOpen.addEventListener('click', function () {
            document.body.classList.add('overflow-hidden');
        });
    }
    const quick_adds =  document.querySelectorAll('button[type="button"].js-quick-add');
     if(quick_adds.length > 0) {
        quick_adds.forEach(function(quick_add){
            quick_add.addEventListener('click',function(){
                 document.body.classList.add('overflow-hidden');
            });
        });
     }   
    document.addEventListener('click', function (e) {
        if (e.target.matches('.js-overlay') || e.target.matches('button.drawer__close-btn')) {
            document.body.classList.remove('overflow-hidden');
            //console.log('remove');
        }
    });
    
  
});
